// export const API_ENDPOINT = "http://localhost:7000/courier-crm/";
export const API_ENDPOINT = "https://api.redmorus.com/courier-crm/";
export const ENTERPRISE = "ENTRPSE";
export const ENTERPRISE_DATA = "ENPXDTA";
export const USER_PERMISSION = "ENTPERM";
export const USER_ROLE = "CRM_U_ROLE";
export const USER_ACCOUNT_ID = "CRM_ACC_ID";
export const USER_USERNAME = "CRM_ACC_USERNAME";
export const USER_NAME = "CRM_ACC_NAME";
export const USER_ID = "CRM_UID";
export const USER_TOKEN = "CRM_U_TOKEN"; // Data of USER_TOKEN = USER_TOKEN_COOKIE
export const LOGIN_CLIENT_IP_COOKIE = "MSTR_U_REQ";
export const USER_TOKEN_COOKIE = "MSTR_U_TOKEN";
export const X_VERIFY_TOKEN_COOKIE = "MSTR_X_VERIFY_TOKEN";
export const APP_LANGUAGE = "CRM_APP_LANG";
// export const APP_NAME = "CourierCRM1.3.10";
export const APP_NAME = "CRM1.3.10";
export const CN_TYPES = ["Document", "Parcel", "Electronic", "Gift", "Passport", "Other"];
export const CN_METHOD = ["Express", "Surface", "Air", "Premium", "Other"];

console.log("%cDeveloper Console", "color: orange; font-size:3em; text-shadow:-1px 0 red, 0 1px red, 1px 0 red, 0 -1px red;"); 
console.log("Application Name", APP_NAME);
